import { ref } from 'vue';
import CookiesUtility, { cookieNames } from '@/Utils/CookiesUtility';

const expirationDays = 365;

// Module scope: the switch in account settings and the celebration behind it read one value.
// A cookie rather than WebStorage, because the preference has to hold for signed-out visitors.
// Asking the system for less motion counts as asking for no effects.
const prefersReducedMotion = typeof matchMedia === 'function'
    && matchMedia('(prefers-reduced-motion: reduce)').matches;
const isEffectsDisabled = ref(CookiesUtility.hasCookie(cookieNames.celebratoryEffectsDisabled)
    || prefersReducedMotion);

export const useEffectsPreference = () => {
    const setEffectsDisabled = (value) => {
        if (value) {
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + expirationDays);

            CookiesUtility.set(cookieNames.celebratoryEffectsDisabled, true, expirationDate, '/');
        }
        else {
            CookiesUtility.remove(cookieNames.celebratoryEffectsDisabled, '/');
        }

        isEffectsDisabled.value = value;
    };

    return {
        isEffectsDisabled,
        setEffectsDisabled,
    };
};
